import { useGetPublicEcomConfigQuery } from "Services/EcomConfigPublicApiSlice";

const PLANT = process.env.REACT_APP_PLANT || "";

export const useEcomConfig = () => {
  const { data: ecomConfig, isLoading, error } = useGetPublicEcomConfigQuery(PLANT);

  const numberOfDecimal =
    ecomConfig?.numberOfDecimal != null
      ? parseInt(ecomConfig.numberOfDecimal, 10)
      : 0;

  // allow_LTAVAILINVQTY is not part of the public config DTO; defaults to 0 (safe/disabled) until added.
  const allowLTAVAILINVQTY = (ecomConfig as any)?.allow_LTAVAILINVQTY || 0;
  const showAuthor = ecomConfig?.isAuthor === 1;
  const showLanguage = ecomConfig?.isLanguage === 1;
  const showAcademic = ecomConfig?.isAcademic === 1;
  const showMerchandise = ecomConfig?.isMerchandise === 1;
  const showOffers = ecomConfig?.isOffers === 1;
  const showEvents = ecomConfig?.isEvents === 1;
  const showGlossary = ecomConfig?.isGlossary === 1;
  const showHistory = ecomConfig?.isHistory === 1;
  const showPromotion = ecomConfig?.isPromotion === 1;
  const showSellBooks = ecomConfig?.isSellBook === 1;
  const isLoyaltyPointsEnabled = ecomConfig?.isLoyaltyPointsEnabled ?? false;
  const isWalletEnabled = ecomConfig?.isWalletEnabled ?? false;
  const rawMaxCartQty = ecomConfig?.maxCartQtyPerProduct ?? 0;
  const maxCartQty = rawMaxCartQty > 0 ? rawMaxCartQty : Infinity;
  const minInvQtyPerProduct = ecomConfig?.minInvQtyPerProduct ?? 0;

  return {
    ecomConfig,
    isLoading,
    error,
    numberOfDecimal,
    allowLTAVAILINVQTY,
    showAuthor,
    showLanguage,
    showAcademic,
    showMerchandise,
    showOffers,
    showEvents,
    showGlossary,
    showHistory,
    showPromotion,
    showSellBooks,
    isLoyaltyPointsEnabled,
    isWalletEnabled,
    maxCartQty,
    minInvQtyPerProduct,
  };
};
